<template>
    <Row>
      <Column :width="15" :key="redraw">
        <div id="detailsModal" class="rc-modal-dialog">
          <!-- Modal content -->
          <div class="rc-modal-content-dialog-inner-wide-tall">
            <div class="rc-modal-header-dialog">
              <Box :key="redrawHeader">
                <Row 
                  v-for="(row, rowIndex) in viewHeaderData" 
                  :key="rowIndex" >
                    <CellFactory 
                      :rowData="row.data"
                      :showMissingRequirements="showMissingRequirements"
                      v-on:withValue="withFieldValue"
                      v-on:withButtonPressed="withButtonPressed"
                      />
                </Row>
              </Box>
            </div>
  
            <div class="rc-modal-body-dialog">
              <div class="rc-modal-body-inner-dialog rc-border-thin">
                <Box :key="redrawMain">
                  <Row 
                    v-for="(row, rowIndex) in viewBodyData" 
                    :key="rowIndex" >
                      <CellFactory 
                        :rowData="row.data"
                        :showMissingRequirements="showMissingRequirements"
                        v-on:withValue="withFieldValue"
                        v-on:withButtonPressed="withButtonPressed"
                        />
                  </Row>
                </Box>
              </div>
            </div>
  
            <div class="rc-modal-footer-dialog">
              <Box>
                <Row 
                  v-for="(row, rowIndex) in viewFooterData" 
                  :key="rowIndex" >
                    <CellFactory 
                      :rowData="row.data"
                      :showMissingRequirements="showMissingRequirements"
                      v-on:withValue="withFieldValue"
                      v-on:withButtonPressed="withButtonPressed"
                      />
                </Row>
              </Box>
            </div>
          </div>
        </div>
      </Column>
    </Row>
</template>

<script> 

import { mapActions, mapGetters } from 'vuex';

import ConnectionUtils from '@/utils/ConnectionUtils.js';
import ConstUtils from '@/utils/ConstUtils.js';
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import MC from "@/domain/session/MC.js";

import CellFactory from "@/portals/shared/cell/CellFactory.vue";
import Box from "@/portals/shared/library/box/Box.vue";
import Column from "@/portals/shared/library/box/Column.vue";
import Row from "@/portals/shared/library/box/Row.vue";

import TitleDisplayRow from "@/portals/shared/cell/title/TitleDisplayRow";
import ButtonDisplayRow from "@/portals/shared/cell/button/ButtonDisplayRow";
import RowDisplayRow from "@/portals/shared/cell/row/RowDisplayRow";
import SpacerDisplayRow from '@/portals/shared/cell/spacer/SpacerDisplayRow';
import ImageDisplayRow from '@/portals/shared/cell/image/ImageDisplayRow';
import ValueDisplayRow from "@/portals/shared/cell/value/ValueDisplayRow.js";
import BoxDisplayRow from "@/portals/shared/cell/box/BoxDisplayRow";

import Inspection from "@/domain/model/inspection/Inspection.js";

export default {
  name: "vehicle-list-repair-image-row",
  components: {
    CellFactory,
    Box, Column, Row,
  },

  props: {
    itemId: { type: String, default: "" },
    commentId: { type: String, default: "" },
    incomingImageIndex: { type: Number, default: 0 },
  },

  data() {
    return {
        redraw: 1,
        redrawMain: 10000,
        redrawHeader: 1000,

        MC: new MC(),
        Strings: StringUtils,
        Contents: ContentUtils,
        Consts: ConstUtils,

        showMissingRequirements: false,
        viewHeaderData: [],
        viewBodyData: [],
        viewFooterData: [],

        inspection: null,
        company: null,
        images: [],

        index: 0,

        kvps: {},
        error: null,
        showDialog: null,
    }
  },

  computed: {
    ...mapGetters([
                   'auth_connected',
                   'auth_socket_status',
                   'signin_event',
                   'auth_client',
                   'domain',
                   ]),
  },

  watch: {
    auth_connected() {
      ConnectionUtils.sendSignInEvent(this);
    },
    auth_socket_status() {
      ConnectionUtils.displayStatus(this);
    },
    signin_event() {
      ConnectionUtils.createDomainSession(this);
    }
  },

  mounted: function () {
    ConnectionUtils.ensureConnection(this);
  },

  methods: {
    ...mapActions([
                   'addListenerAction',
                   'removeListenerAction',
                   'updateDomain',
                   'AuthStorage_updateCompany',
                   ]),
    
    start: function() {
      this.inspection = new Inspection(this.domain);
      if (StringUtils.isNotEmpty(this.itemId)) {
        var id = ContentUtils.baseDecode(this.itemId);
        this.inspection = this.domain.inspections().findById(id).copy();
        this.company = this.inspection.company().find();

        var commentMap = this.inspection.comments().find();
        var comments = commentMap.sorted();
        for (var commentIndex = 0; commentIndex < comments.length; commentIndex++) {
          var comment = comments[commentIndex];
          if (comment.id() == this.commentId) {
            this.images = comment.images().find().sortByIndex();
            break;
          }
        }
        this.index = this.incomingImageIndex;
      }
      this.setup();
      this.mainScreen();
    },

    setup: function() {
      // window.onclick = this.onClick;
    },

    mainScreen() {
      this.viewHeaderData = [];
      this.viewBodyData = [];
      this.viewFooterData = [];

      let fullScreenButton = new ButtonDisplayRow().withWidth("2").withField("FullScreen").withName("Full Screen");
      let closeButton = new ButtonDisplayRow().withWidth("2").withField("CloseDialog").withName("Close");
      let previousButton = new ButtonDisplayRow().withWidth("1").withField("Previous").withName("<");
      let nextButton = new ButtonDisplayRow().withWidth("1").withField("Next").withName(">");

      let footerRow = new RowDisplayRow()
        .withChild(closeButton)
        .withChild(new SpacerDisplayRow().withWidth(11))
        .withChild(previousButton)
        .withChild(nextButton);
      
      this.viewHeaderData.push(new TitleDisplayRow().withTitle("Inspection Image Remarks"));
      this.viewFooterData.push(footerRow);

      let imageBox = new BoxDisplayRow().withWidth("15");
      let headerRow = new RowDisplayRow().withWidth("15");
      let imageIndex = this.index + 1;
      let imageIndexDisplay = new ValueDisplayRow()
        .withValue("Image " + imageIndex + " of " + this.images.length)
        .withWidth("13");
      headerRow.withChild(imageIndexDisplay);
      headerRow.withChild(fullScreenButton);

      this.viewHeaderData.push(headerRow);

      let image = this.images[this.index];
      let imageRow = new ImageDisplayRow()
        .withImageUrl(image.imageDisplay())
        .withWidth("15");

      imageBox.withChild(imageRow);

      this.viewBodyData.push(imageBox);
    },

    paint: function() {
      this.redraw++;
    },

    paintHeader: function() {
      this.redrawHeader++;
    },

    onClick: function(event) {
      var modal = document.getElementById("detailsModal");
      if (event.target == modal) {
        this.goBack();
      }
    },

    log() {
      return this.domain.logger();
    },

    resetMissingValues() {
      if (this.showMissingRequirements) {
        this.showMissingRequirements = false;
      }
    },

    withFieldValue: function(valueData) {
      if (valueData) {
        this.domain.logger().info("Received: {0}", [JSON.stringify(valueData)]);
        this.resetMissingValues();

        if (!valueData) {
          return;
        }

        this.$emit("withFieldValue", valueData);
      }
    },

    withButtonPressed: function(buttonData) {
      if (buttonData["field"] == "Previous") {
        if (this.index > 0) {
          this.index--;
          this.mainScreen();
          this.paintMain();
          this.paintHeader();
        }
      }
      if (buttonData["field"] == "Next") {
        if (this.index < this.images.length - 1) {
          this.index++;
          this.mainScreen();
          this.paintMain();
          this.paintHeader();
        }
      }

      if (buttonData["field"] == "FullScreen") {
        window.open(this.images[this.index].imageDisplay(), "_blank");
      }

      if (buttonData["field"] == "CloseDialog") {
        this.$emit("withButtonPressed", buttonData);
      }
      
    },

    paintMain: function() {
      this.redrawMain++;
    },

    displayProgress: function(msg) {
      this.callback(msg);
    },

    callback: function(msg) {
      if (msg) {
        //
      }
    },

    goBack: function() {
      this.$router.back();
    },

    areRequirementsMet() {
      var met = true;
      return met;
    },

  }
}

</script>